import { render, staticRenderFns } from "./ProjectViewUsage.vue?vue&type=template&id=33e6e0ec&scoped=true&"
import script from "./ProjectViewUsage.vue?vue&type=script&lang=js&"
export * from "./ProjectViewUsage.vue?vue&type=script&lang=js&"
import style0 from "./ProjectViewUsage.vue?vue&type=style&index=0&id=33e6e0ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e6e0ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDataTable,VDivider,VRow})
